import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme, keyframes } from '@mui/material/styles';
import NightsStayRoundedIcon from '@mui/icons-material/NightsStayRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.5; }
  70% { transform: scale(1.55); opacity: 0; }
  100% { transform: scale(1.55); opacity: 0; }
`;

const twinkle = keyframes`
  0%, 100% { opacity: 0.35; transform: scale(0.85); }
  50% { opacity: 1; transform: scale(1); }
`;

export default function NightRestrictionScreen() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: theme.zIndex.modal + 1,
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: '24px',
        direction: 'rtl',
        overflow: 'hidden',
      }}
    >
      <AutoAwesomeRoundedIcon
        sx={{
          position: 'absolute',
          top: '18%',
          left: '22%',
          fontSize: '18px',
          color: 'text.secondary',
          opacity: 0.5,
          animation: `${twinkle} 3.2s ease-in-out infinite`,
        }}
      />
      <AutoAwesomeRoundedIcon
        sx={{
          position: 'absolute',
          top: '68%',
          left: '16%',
          fontSize: '12px',
          color: 'text.secondary',
          opacity: 0.4,
          animation: `${twinkle} 2.4s ease-in-out infinite 0.6s`,
        }}
      />
      <AutoAwesomeRoundedIcon
        sx={{
          position: 'absolute',
          top: '24%',
          right: '18%',
          fontSize: '14px',
          color: 'text.secondary',
          opacity: 0.45,
          animation: `${twinkle} 2.8s ease-in-out infinite 0.3s`,
        }}
      />
      <AutoAwesomeRoundedIcon
        sx={{
          position: 'absolute',
          bottom: '22%',
          right: '24%',
          fontSize: '16px',
          color: 'text.secondary',
          opacity: 0.5,
          animation: `${twinkle} 3.6s ease-in-out infinite 1s`,
        }}
      />

      <Stack
        spacing={3}
        alignItems="center"
        textAlign="center"
        sx={{ maxWidth: '340px' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '112px',
            height: '112px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              border: `1.5px solid ${theme.palette.primary.main}`,
              animation: `${pulse} 2.6s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
            }}
          />
          <Box
            sx={{
              width: '96px',
              height: '96px',
              borderRadius: '50%',
              bgcolor: 'background.card',
              border: `1px solid ${theme.palette.divider}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <NightsStayRoundedIcon
              sx={{ fontSize: '48px', color: theme.palette.primary.main }}
            />
          </Box>
        </Box>

        <Stack spacing={1}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
            دسترسی به اپلیکیشن موقتاً محدود شده
          </Typography>
          <Typography
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              fontSize: '15px',
              lineHeight: 1.9,
            }}
          >
            شیپیتو تنها در بازه‌ی ساعت 7 تا 22 در دسترس است
            <br />
            لطفاً فقط در همین بازه‌ی زمانی تلاش کنید
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
